var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToJobsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_51957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.25l1.058-1.057L4.372 9.75H16.5v-1.5H4.372l3.443-3.442L6.75 3.75 1.5 9l5.25 5.25z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_51957"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#344054",
    transform: "rotate(180 9 9)",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToJobsBlack);
export default __webpack_public_path__ + "static/media/back-to-jobs-black.c00a6f14f806a5d0725e641eb91d31c1.svg";
export { ForwardRef as ReactComponent };